import { useContext } from 'react'
import { ToastContext, type ToastApi } from './ToastProvider'

/**
 * Access the toast notification API provided by `<ToastProvider>`.
 * Throws when used outside a provider so mistakes surface immediately.
 */
export function useToast(): ToastApi {
  const ctx = useContext(ToastContext)
  if (!ctx) {
    throw new Error('useToast must be used within a <ToastProvider>')
  }
  return ctx
}

export default useToast
